var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFailed(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.09 5.61351L8.41061 7.29289L6.73123 5.61351C6.68262 5.5649 6.60307 5.5649 6.55445 5.61351L6.02412 6.14384C5.97551 6.19246 5.97551 6.27201 6.02412 6.32062L7.7035 8L6.02412 9.67938C5.97551 9.72799 5.97551 9.80754 6.02412 9.85616L6.55445 10.3865C6.60307 10.4351 6.68262 10.4351 6.73123 10.3865L8.41061 8.70711L10.09 10.3865C10.1386 10.4351 10.2182 10.4351 10.2668 10.3865L10.7971 9.85616C10.8457 9.80754 10.8457 9.72799 10.7971 9.67938L9.11772 8L10.7971 6.32062C10.8457 6.27201 10.8457 6.19246 10.7971 6.14384L10.2668 5.61351C10.2182 5.5649 10.1386 5.5649 10.09 5.61351Z",
    fill: "#E12121"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.41016 1C4.54453 1 1.41016 4.13438 1.41016 8C1.41016 11.8656 4.54453 15 8.41016 15C12.2758 15 15.4102 11.8656 15.4102 8C15.4102 4.13438 12.2758 1 8.41016 1ZM8.41016 13.8125C5.20078 13.8125 2.59766 11.2094 2.59766 8C2.59766 4.79063 5.20078 2.1875 8.41016 2.1875C11.6195 2.1875 14.2227 4.79063 14.2227 8C14.2227 11.2094 11.6195 13.8125 8.41016 13.8125Z",
    fill: "#E12121"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFailed);
export default __webpack_public_path__ + "static/media/failed.af2f7e128a17da0a913873f122365687.svg";
export { ForwardRef as ReactComponent };